import { atom } from "jotai";

const stored = localStorage.getItem("theme") as "dark" | "light" | null;
const initial = stored || "dark";

// Apply on load
if (initial === "light") {
  document.documentElement.classList.add("light");
}

export const themeAtom = atom<"dark" | "light">(initial);
